
    export default 
    {
    "chore": {
        "banner": {
            "content": "¡Descubre el recorrido que siguen tus paquetes!",
            "learn_more": "MÁS INFORMACIÓN"
        }
    }
}